import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CallingFromDropdown from "../CallingFromDropdown";
import { Flex } from "@fluentui/react-northstar";
import { observer } from "mobx-react-lite";
import CallNumber from "../CallNumber";
import StatusCodes from "../../../constants/status-codes";
import * as microsoftTeams from "@microsoft/teams-js";
import outboundDialHandler from "../../../services/api/outboundDial";

const CallingContainer = observer((props) => {
  const {
    teams,
    currentStatusCode,
    currentCallTeamId,
    setCurrentCallTeamId,
  } = props;

  const [currentCallNumber, setCurrentCallNumber] = useState(null);

  // if only one team, set current calling from team to that one
  useEffect(() => {
    // if one team then select that team
    if (teams.length === 1) {
      setCurrentCallTeamId(teams[0].team.id);
    } else {
      // if we aren't logged into the cuurent call team, set currentCallTeamId to null
      const inTeam = teams.find((item) => item.team.id === currentCallTeamId);
      if (!inTeam) {
        setCurrentCallTeamId(null);
      }
    }
  }, [teams, currentCallTeamId, setCurrentCallTeamId]);


  const onCallNumberChanged = (event) => {
    // allow numbers prefixed by an optional +
    let value = event.target.value;

    // Get only characters + and digits 0-9
    value = value.replace(/[^0-9+]+/g, '');

    // If the string contains +'s anywhere but the begining, remove them
    if(value.length > 1) {
      value =  value.substring(0,1) +               // Keep first character
               value.substring(1).replace('+','');  // Replace +'s eveywhere else with blanks
    }

    setCurrentCallNumber(value);
  }

  const onCallButtonClicked = async () => {
    // Make call to web api
    try {
      let response = await outboundDialHandler.outboundDial(currentCallTeamId, currentCallNumber);
      const url = 'tel:' + encodeURI(response.accessNumber);

      microsoftTeams.executeDeepLink(url, (status, reason) => {
        if (status) {
          setCurrentCallNumber("");
        }
      });
    } catch {
      console.warn("outboundDial failed");
    }
  }

  const wrapUp = currentStatusCode.code === StatusCodes.WRAP_UP;
  const disableButton = !currentCallTeamId || !currentCallNumber || wrapUp;
  const disableInput = !currentCallTeamId || wrapUp;

  return (
    <Flex column data-testid="callingContainer" gap="gap.small" className="calling-container">
      <CallNumber
        disableInput={disableInput}
        disableButton={disableButton}
        onCallNumberChanged={onCallNumberChanged}
        onCallButtonClicked={onCallButtonClicked}
        number={currentCallNumber}
        wrapUpShowWarning={wrapUp}
      />
      <CallingFromDropdown
        items={teams}
        currentCallTeamId={currentCallTeamId}
        onChange={setCurrentCallTeamId}
      />
    </Flex>
  );
});

CallingContainer.propTypes = {
  teams: PropTypes.array,
  currentStatusCode: PropTypes.object,
};

CallingContainer.defaultProps = {
  teams: [],
};

export default CallingContainer;
